import { Injectable } from '@angular/core';
import { State } from '@ngxs/store';
import { ISessionState, SessionState } from './session/session.reducer';

export interface ICoreState {
  session: ISessionState;
}

const initStates: ICoreState = {
  session: null,
};

@State<ICoreState>({
  name: 'core',
  defaults: initStates,
  children: [SessionState],
})
@Injectable()
export class CoreState {}
